import React, { PureComponent } from "react";
import _ from "lodash";
import { ContentOwnersStyle } from "../styles/ContentOwnersStyle";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  WithStyles,
  withStyles,
  TableHead,
  TextField,
  MenuItem,
  Grid,
  Typography,
  Link,
  Button,
} from "@material-ui/core";
import {
  MyPATTextArea,
  MyPATTextField,
  MyPATDialog,
  MyPATMultiSearch,
} from "../../common";
import MyPATCalendar from "../../common/MyPATCalendar";
import { onlyAllowNumbers } from "../../../utils";
import InputViaDialog from "../common/InputViaDialog";
import { ContentSubType } from "../../test-template/types/ContentSubTypeBody";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import { userStyles } from "../styles";
import contentRequestServices from "../services/contentRequestServices";
import SelectTestOwners from "./SelectTestOwners";
import {
  ContentRequest,
  Question,
  Roles,
  Owners,
  TestDetails,
  RequestInfo,
} from "../types/ContentRequest";
import PerfectScrollbar from "react-perfect-scrollbar";
import { format } from "date-fns";
import classNames from "classnames";
interface Props extends WithStyles<typeof ContentOwnersStyle> {
  contentsubType: ContentSubType[];
  transferToParent: (requestData: ContentRequest) => void;
  requestData: ContentRequest;
  isSectionDisabled?: boolean;
}

interface State {
  testOwnerData: any;
  showContentAuthorsPopup: boolean;
  usersList: any;
  authors: any[];
}

class TestOwnersTable extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      testOwnerData: {},
      showContentAuthorsPopup: false,
      usersList: [],
      authors: [],
    };
    this.handleChange = _.debounce(this.handleChange, 200);
    this.getAuthorAndEndDateRenderValue = this.getAuthorAndEndDateRenderValue.bind(
      this
    );
  }

  handleChange = () => {
    const requestData = { ...this.props.requestData };
    const requestInfo: RequestInfo = {...requestData.requestInfo};
    const testDetails: TestDetails = {
      ..._.get(requestInfo, "details.testDetails", {}),
    };
    const { testOwnerData } = { ...this.state };
    testDetails.description = testOwnerData.description;
    testDetails.type = testOwnerData.type;
    requestInfo.totalCount = testOwnerData.totalCount || "";
    requestInfo.details.testDetails = testDetails;
    requestData.requestInfo = requestInfo;
    console.log("handleChange", { requestData });
    this.props.transferToParent(requestData)
  };

  handleClosePopup = () => {
    this.setState({
      showContentAuthorsPopup: false,
    });
  };

  handleShowContentAuthorsPopup = () => {
    this.setState({
      showContentAuthorsPopup: true,
    });
  };
  componentDidMount = () => {
    this.reInitialiseTestOwnerData();
  };
  reInitialiseTestOwnerData = () => {
    const requestData = { ...this.props.requestData };
    const requestInfo: RequestInfo = { ...requestData.requestInfo };
    const testDetails: TestDetails = {
      ..._.get(requestInfo, "details.testDetails", {}),
    };
    const testOwnerData: { type: string, totalCount: string | number; description: string } = { type: "", totalCount: "", description: "" };
    if (testDetails) {
      const { type, description } = testDetails;
      testOwnerData.type = type || "none";
      testOwnerData.description = description ? description : "";
    }
    if (requestInfo.totalCount) {
      testOwnerData.totalCount = requestInfo.totalCount;
    }
    
    this.setState({ testOwnerData });
  };
  componentDidUpdate(prevProps: Props, prevState: State) {
    const prevTestType = _.get(prevProps, 'requestData.requestInfo.details.testDetails.type', '');
    const currentTestType = _.get(this.props, 'requestData.requestInfo.details.testDetails.type', '');

    if (prevTestType !== currentTestType) {
      this.reInitialiseTestOwnerData()
    }
    if (prevState.testOwnerData !== this.state.testOwnerData) {
      this.handleChange();
    }
  }

  setFieldValue = (event: any) => {
    const { value, name } = event.target;
    this.setState((prevState) => {
      const newTestOwnerData = { ...prevState.testOwnerData };
      newTestOwnerData[name] = value;
      return {
        ...prevState,
        testOwnerData: newTestOwnerData,
      };
    });
  };

  onChange = (newRequestData: ContentRequest) => {
    this.props.transferToParent(newRequestData);
  };
  
  getAuthorAndEndDateRenderValue = () => {
    const requestData = { ...this.props.requestData };
    const authors = _.get(
      requestData,
      "requestInfo.details.testDetails.authors",
      []
    );
    const owners: Owners[] = _.get(requestData, "requestInfo.owners", []);
    const owner = owners.find(({ type }) => {
      return type === "test-compiler";
    });
    if (!owner) {
      return [];
    }
    const { roles } = { ...owner };
    const types = [
      "creator",
      "evaluator",
      "languageEvaluator",
      "moderator",
      "publisher",
    ];
    const values: any[] = [];
    types.map((type) => {
      let deadline = "";
      const author = authors.find((author: any) => author.type == type);
      // @ts-ignore
      if (roles && roles[`${type}`] && roles[`${type}`].endDate) {
        //  @ts-ignore
        deadline = format(new Date(roles[`${type}`].endDate), "dd MMM ");
      }
      const authorName = (author && author.name) || "";
      if (authorName.length > 0 || deadline.length > 0) {
        //  values.push(`${_.capitalize(type)}: ${authorName} Deadline:${deadline}`);
        values.push({ type: type, author: authorName, deadline: deadline });
      }
    });
    return values;
  };
  renderAuthorDeadline = (values: any[]) => {
    const { classes } = this.props;
    return values.map((value: any) => {
      return (
        <Grid container>
          <Grid item xs={6}>
            <span className={classes.fontBold}>
              {_.capitalize(
                value.type === "languageEvaluator" ? "L.evaluator" : value.type
              )}{" "}
              :
            </span>
            <span className={classes.grayFont}>
              {value.author.length > 0 ? value.author : "N/A"}
            </span>
          </Grid>
          <Grid item xs={6}>
            <span className={classes.fontBold}> Deadline :</span>
            <span className={classes.grayFont}>
              {value.deadline.length > 0 ? value.deadline : "N/A"}
            </span>
          </Grid>
        </Grid>
      );
    });
  };

  renderTestTypeName = (testType: string) => {
    const { contentsubType } = this.props;

    // TODO - Confirm from product how to handle same type
    const contentSubTypeSet = new Set();
    const contentSubTypeToShow = contentsubType.filter((type) => {
      if (contentSubTypeSet.has(type.code)) {
        return false;
      }
      contentSubTypeSet.add(type.code);
      return true;
    });
    const subType = contentSubTypeToShow.find(
      ({ code }) => code.toString() === testType.toString()
    );
    if (subType) {
      return subType.name;
    }
    return "Select Test Type";
  };

  render() {
    const { classes, requestData, isSectionDisabled } = this.props;
    const { testOwnerData } = this.state;

    const isTestTypeSelected =
      testOwnerData.type && testOwnerData.type !== "none";
    return (
      <>
        <Table className={classes.OwnerTable}>
          <TableHead>
            <TableRow classes={{ root: classes.tableHeading }}>
              <TableCell>
                <strong>Test Type</strong>
              </TableCell>
              <TableCell>
                <strong>Count</strong>
              </TableCell>
              <TableCell>
                <strong>
                  Specify content Authors &amp; Deadlines
                  <CustomInfoIcon
                    infoDialogContentType="Specify content Authors &amp; Deadlines"
                    isCenterArrow={true}
                    isRightArrow={false}
                    isInfoIcon={true}
                    knowMoreAbout={false}
                    dialogTitle="Specify content Authors &amp; Deadlines"
                    imageURL="/assets/svg/contentRequest/Deadlines.svg"
                    dialogPara=""
                    details="Click to know more"
                    toolTipDirection="top"
                    htmlElement={
                      <>
                        <Grid container justify="center" className={classes.mtb30}>
                          <Typography className={classes.font16}>In this column,you can assign role category to authors in your organization. There are five categories and the workflow also follow as per the order below:
</Typography>
                        <Typography className={classes.font16}>Creator, Evaluator, Language Evaluator, Moderator, Publisher
</Typography>
                        <Typography className={classes.font16}>An author can be mapped with one role category in a request. You need to click + icon to add authors in this table</Typography>
                        </Grid>
                      </>
                    }
                  />
                </strong>
              </TableCell>
              <TableCell>
                <strong>Additional Description</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell className={classes.dropDownInput}>
                <Typography
                  variant="body2"
                  align="left"
                  inline
                  className={classNames(
                    !isTestTypeSelected && classes.greyText
                  )}
                >
                  {isTestTypeSelected
                    ? this.renderTestTypeName(testOwnerData.type)
                    : "Select Test Type"}
                </Typography>
              </TableCell>
              <TableCell>
                <div className={classes.posRelative}  style={{width: '70px'}}>
                  <MyPATTextField
                    fullWidthControl
                    inputId="count"
                    name="totalCount"
                    value={testOwnerData.totalCount}
                    type="number"
                    placeholder="Ex. 1"
                    onChange={this.setFieldValue}
                    onKeyPress={onlyAllowNumbers}
                    inputProps={{ min: "1" }}
                    disabled={isSectionDisabled}
                  />
                </div>
              </TableCell>
              <TableCell
                style={
                  this.getAuthorAndEndDateRenderValue().length === 0
                    ? { height: "36px" }
                    : { height: "95px" }
                }
              >
                <div
                  className={[classes.addAuthor, classes.placeholderFont].join(
                    " "
                  )}
                  style={
                    this.getAuthorAndEndDateRenderValue().length === 0
                      ? { height: "40px" }
                      : { height: "95px" }
                  }
                >
                  <PerfectScrollbar>
                    <InputViaDialog
                      placeholder="Add Content Owners"
                      value={this.getAuthorAndEndDateRenderValue()}
                      handleAddOrEdit={this.handleShowContentAuthorsPopup}
                      renderer={this.renderAuthorDeadline.bind(this)}
                      disabled={isSectionDisabled}
                    />
                  </PerfectScrollbar>
                </div>
              </TableCell>
              <TableCell classes={{ root: classes.hideDefaultScroll }}>
                <div>
                  <MyPATTextArea
                    inputId="description"
                    name="description"
                    onChange={this.setFieldValue}
                    value={testOwnerData.description}
                    multiline
                    fullWidthControl
                    placeholder="Add extra requirements for your test"
                    disabled={isSectionDisabled}
                  />
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        {this.state.showContentAuthorsPopup && (
          <SelectTestOwners
            requestData={requestData}
            onClose={this.handleClosePopup}
            onDone={this.handleShowContentAuthorsPopup}
            transferToParent={this.onChange.bind(this)}
          />
        )}
      </>
    );
  }
}

// @ts-ignore
export default withStyles(ContentOwnersStyle)(TestOwnersTable);
